import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";
import classNames from "classnames/bind";
import {CHAT_TYPE} from "utils";
import * as request from "api-socket/chat";
import PersonalChatSearch from "./PersonalChatSearch";
import SearchIcon from "images/icn_search_personal_chat.svg";
import CloseIcon from "images/icn_dismiss_personal_chat.svg";
import profileDefaultImage from "images/common/avatar-default-profile-image.png";
import styles from "./index.module.scss";

function PersonalChatPopup({isShowPrivatePopUp, setIsShowPrivatePopUp, setSelectedUser, onClickChatType, onClickChatOption}) {
  const defaultImage = profileDefaultImage;
  const cn = classNames.bind(styles);
  const roomName = useSelector(state => state.chat.currentRoom);
  const userInfo = useSelector(state => state.userinfo);
  const tabList = ["WORLD", "FOLLOWERS", "FOLLOWING"];
  const [currentTab, setCurrentTab] = useState(tabList[0]);
  const [currentUser, setCurrentUser] = useState(null);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [list, setList] = useState([]);

  const onClickClose = () => {
    setIsShowPrivatePopUp(false);
    onClickChatOption(null);
  };

  const onClickSearch = () => {
    setCurrentUser(null);
    handleSearchMode();
  };

  const handleSearchMode = () => {
    setIsSearchMode(isSearchMode => !isSearchMode);
  };

  const onClickTab = tab => {
    if (tab === currentTab) return;
    setCurrentTab(tab);
    setCurrentUser(null);
    switch (tab) {
      case tabList[0]:
        return getWorldUsers();
      default:
        break;
    }
  };

  const onClickChatStart = () => {
    setSelectedUser(currentUser);
    onClickChatType(CHAT_TYPE.PRIVATE_MESSAGE);
    onClickClose();
  };

  useEffect(() => {
    setCurrentTab(tabList[0]);
    getWorldUsers();
  }, []);

  const getWorldUsers = async () => {
    await request
      .getWorldUsers_v2(roomName)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const dataList = Object.values(data.list);
          const list = dataList.map(user => JSON.parse(user));
          const result = list.filter(user => user.name !== userInfo.name);
          setList(result);
        }
      });
  };

  const onClickUser = user => {
    setCurrentUser(user);
  };

  return (
    <div className={cn("private_message", isShowPrivatePopUp && "show")}>
      <div className={styles.wrap}>
        {isSearchMode ? (
          <PersonalChatSearch
            currentUser={currentUser}
            onClickClose={onClickClose}
            onClickUser={onClickUser}
            handleSearchMode={handleSearchMode}
            onSubmit={onClickChatStart}
          />
        ) : (
          <>
            <div className={styles.head}>
              <h3 className={styles.title}>
                <FormattedMessage id="ID_CHAT_SIDE_SLIDE_PERSONAL_CHAT_TITLE" />
              </h3>
              <div className={styles.option_btns}>
                <button className={styles.search_btn} onClick={onClickSearch} type="button">
                  <img alt="search" src={SearchIcon} />
                </button>
                <button className={styles.close_btn} onClick={onClickClose} type="button">
                  <img alt="close" src={CloseIcon} />
                </button>
              </div>
            </div>

            <div className={styles.category}>
              {tabList.map((tab, i) => (
                <button
                  key={i}
                  className={cn("category_title", tab === currentTab && "active")}
                  type="button"
                  onClick={() => onClickTab(tab)}
                >
                  <FormattedMessage id={`ID_CHAT_SIDE_SLIDE_CATEGORY_${tab}`} />
                </button>
              ))}
            </div>

            <div className={styles.chat_list}>
              <ul className={styles.chat_list_wrap}>
                {list?.length === 0 && (
                  <p className={styles.chat_list_placeholder}>
                    <FormattedMessage id={`ID_PRIVATE_CHAT_PLACEHOLDER_${currentTab}`} />
                  </p>
                )}
                {list?.map(user => {
                  let icon = user.icon;
                  if (!icon) {
                    icon = defaultImage;
                  }
                  const id = user.id ? user.id : user.ci;
                  const currentUserId = currentUser?.id ? currentUser.id : currentUser?.ci;
                  return (
                    <li className={cn("chat_list_item", id === currentUserId && "active")} key={id} onClick={() => onClickUser(user)}>
                      <div className={cn("user_profile_wrap", currentTab === tabList[0] ? "" : user.isWorldConnecting && "enter")}>
                        <img alt="user profile" src={icon} className={styles.chat_user_profile} />
                      </div>
                      <span className={styles.user_nickname}>{user.name}</span>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className={styles.start_chat_btn_wrap}>
              <button type="button" className={cn("start_chat", currentUser && "active")} onClick={onClickChatStart}>
                <FormattedMessage id="ID_CHAT_SIDE_SLIDE_START_CHAT" />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default PersonalChatPopup;
